import { REQUIRED } from "@/util/validation-rules"
import { isDateFuture } from "@/util"
import { DATE_DEFAULT_REGXP } from "@/util/const"

export default class CMExamConfigValidator {
  constructor(data, validator) {
    this.data = data
    this.validator = validator
  }
  
  validate () {
    this.validator.resetFields()
    return this.isValid()
  }

  isValid() {
    this.validateLocation()
    this.validateName()
    this.validateRequired('cbr_location', this.data.cbr_location)
    this.validateRequired('gather_time', this.data.gather_time)
    this.validateRequired('course_start_time', this.data.course_start_time)
    this.validateRequired('course_end_time', this.data.course_end_time)
    this.validateRequired('exam_time', this.data.exam_time)
    this.validateRequired('transport_type', this.data.transport_type)
    this.validateFirstDay()
    return this.validator.isValid()
  }

  validateLocation() {
    if(this.data.meeting_room === -1) return
    if(!this.validateRequired('meeting_room', this.data.meeting_room)) return
  }

  validateName() {
    if(!this.validateRequired('name', this.data.name)) return
  }

  validateFirstDay() {
    if(!this.data.first_day_course_date && !this.data.first_day_course_start_time && !this.data.first_day_course_end_time) return
    this.validateDate('first_day_course_date', this.data.first_day_course_date)
    this.validateRequired('first_day_course_start_time', this.data.first_day_course_start_time)
    this.validateRequired('first_day_course_end_time', this.data.first_day_course_end_time)
  }

  validateDate(field, date) {
    if(!this.data.first_day_course_date) return
    if(!(DATE_DEFAULT_REGXP.test(date))) 
      this.validator.invalidField(
        field ,
        'Date should be in DD-MM-YYYY format'
      )
  }

  validateRequired(field, data) {
    let match = REQUIRED(data)
    if(match === true) return true
    this.validator.invalidField(field, match)
    return false
  }
}